import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Route titles are `nav` keys. Staff routes and test fixtures still carry literal English.
export function useRouteText(): (value: string) => string {
  const { t, i18n } = useTranslation('nav');
  return useCallback(
    (value) => (i18n.exists(value, { ns: 'nav' }) ? t(value as never) : value),
    [t, i18n],
  );
}
